module.exports = __webpack_public_path__ + "static/media/dollorIcon.fa4e4dfc.svg";